import isObject from "lodash/isObject";
import kebabCase from "lodash/kebabCase";
import merge from "lodash/merge";
import reduce from "lodash/reduce";

export function flattenKeys(obj: object, path: string[] = []) {
  if (!isObject(obj)) {
    return {
      [path.join("-")]: obj,
    };
  }

  return reduce(
    obj,
    (acc, next, key): object => {
      return merge(acc, flattenKeys(next, [...path, kebabCase(key)]));
    },
    {},
  );
}
